var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.1139 9.13364L7.51523 5.53498L11.1139 1.93631C11.2181 1.83214 11.2181 1.66167 11.1139 1.5575L9.97748 0.421079C9.8733 0.316907 9.70284 0.316907 9.59867 0.421079L6 4.01975L2.40133 0.421079C2.29716 0.316907 2.1267 0.316907 2.02252 0.421079L0.886103 1.5575C0.781931 1.66167 0.781931 1.83214 0.886103 1.93631L4.48477 5.53498L0.886103 9.13364C0.781931 9.23782 0.781931 9.40828 0.886103 9.51245L2.02252 10.6489C2.1267 10.753 2.29716 10.753 2.40133 10.6489L6 7.05021L9.59867 10.6489C9.70284 10.753 9.8733 10.753 9.97748 10.6489L11.1139 9.51245C11.2181 9.40828 11.2181 9.23782 11.1139 9.13364Z","fill":"#003D0C"}));
}

Close.defaultProps = {"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none"};

module.exports = Close;

Close.default = Close;
